import React from 'react';
import { ErrorMessageTW } from '../errorMessage/ErrorMessageTW';
import { IErrorBoundaryProps } from '../../components/shared/ErrorBoundary';

export class ErrorBoundaryTW extends React.Component<IErrorBoundaryProps, { hasError: boolean; error?: Error }> {
  constructor(props: IErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    this.setState({ ...this.state, error });
  }

  render() {
    if (this.state.hasError) {
      return <ErrorMessageTW error={this.state.error} />;
    }
    return this.props.children;
  }
}
